(function() {
  'use strict';

  angular
    .module('survey.multipleChoice', [])
    .controller('SurveyMultipleChoiceCtrl', SurveyMultipleChoiceCtrl);

  SurveyMultipleChoiceCtrl.$inject = ['$scope'];

  function SurveyMultipleChoiceCtrl($scope) {
    // set to null so index 0 is not selected
    $scope.answerModel = null;
    $scope.answerClass = [];

    $scope.$watch('answerModel', function(newValue) {
      if (newValue === null || newValue === undefined)
        return;

      if ($scope.state.answerSubmitted)
        return;

      $scope.state.answerSelected = true;
      $scope.answer.selectedAnswer = newValue;

      setAnswerClasses();
    });

    $scope.$watch('state', function(newValue) {
      if (!newValue)
        return;

      if ($scope.answerModel != $scope.answer.selectedAnswer)
        $scope.answerModel = $scope.answer.selectedAnswer;

      setAnswerClasses();
    });

    function setAnswerClasses() {
      for (var i = 0; i < $scope.questionAnswers.length; i++) {
        $scope.answerClass[$scope.questionAnswers[i].id] = setClass();
      }
    }

    function setClass() {
      if (!$scope.state.answerSubmitted)
        return '';

      return 'answered';
    }

    function setup() {
      var all = { id: 'all', answer: 'All of the above' };
      var none = { id: 'none', answer: 'None of the above' };

      // indexOf doesn't work because of the added $$hashKey key
      var allIndex = getAnswerIndex(all);
      if (allIndex > -1) {
        $scope.questionAnswers.splice(allIndex, 1);
      }
      var noneIndex = getAnswerIndex(none);
      if (noneIndex > -1) {
        $scope.questionAnswers.splice(noneIndex, 1);
      }

      if ($scope.question.includeAllAbove)
        $scope.questionAnswers.push(all);
      if ($scope.question.includeNoneAbove)
        $scope.questionAnswers.push(none);
    }

    function getAnswerIndex(answer) {
      var index = -1;
      for (var i = 0; i < $scope.questionAnswers.length && index === -1; i++) {
        if ($scope.questionAnswers[i].id != answer.id) continue;
        index = i;
      }
      return index;
    }


    // TODO: Iverson - not used
    $scope.radioItemSurveyClass = function(item) {
      if ($scope.state.answerSubmitted) {
        return item.id === $scope.answer.selectedAnswer ? 'radioCorrect' : '';
      }
      return item.id === $scope.answer.selectedAnswer ? 'radioSelected' : 'radioNotSelected';
    };

    setup();
  }
})();
